import React, { useEffect } from "react";
import { TimelineLite, Power2 } from "gsap";
import { gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
import LogoLoadStyles from "./LogoLoad.module.css";

const LogoLoad = () => {
  let timeline = new TimelineLite({ delay: 0.3, repeat: -1 });

  useEffect(() => {
    gsap.registerPlugin(CSSPlugin);
    timeline.from(".logosvg", 0.2, {
      autoAlpha: 1,
      scale: 0,
      transformOrigin: "center center",
    });

    timeline.to(".logosvg", 1, {
      delay: 0.2,
      duration: 3,
      ease: Power2.Out,
      autoAlpha: 0,
      scale: 1,
      opacity: 0,
      force3D: false,
    });
  });

  return (
    <div className={LogoLoadStyles.main}>
      <div className={LogoLoadStyles.image}>
        <svg
          viewBox="0 0 42 45"
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit="2"
        >
          <path
            className="logosvg"
            d="M4.917 22.157L0 17.894 20.65 0l20.649 17.894-4.918 4.263 4.918 4.26-20.65 17.894L0 26.417l4.918-4.26zM20.65 35.789L7.59 24.473l-2.244 1.944 15.304 13.262 15.305-13.262-2.244-1.944-13.06 11.316zM10.262 22.157l10.387 9 10.388-9-10.388-9.003-10.387 9.003zm16.14-.159l-5.753-4.985-5.752 4.985 5.752 4.985 5.753-4.985zm-6.16 0l.407.353.408-.353-.408-.353-.408.353zm13.468-2.157l2.244-1.947L20.65 4.632 5.345 17.894l2.244 1.947 13.06-11.316L33.71 19.84z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );
};

export default LogoLoad;
